/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, BigNumberish, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../common';
import type { PolicyToken, PolicyTokenInterface } from '../PolicyToken';

const _abi = [
  {
    inputs: [
      {
        internalType: 'string',
        name: 'projectName_',
        type: 'string',
      },
      {
        internalType: 'string',
        name: 'tokenSymbol_',
        type: 'string',
      },
      {
        internalType: 'address',
        name: 'firstOwner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_cashToken',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_startDate',
        type: 'uint256',
      },
      {
        internalType: 'uint256[]',
        name: '_guranteedPayouts',
        type: 'uint256[]',
      },
      {
        internalType: 'uint256[]',
        name: '_nonGuranteedPayouts',
        type: 'uint256[]',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    inputs: [],
    name: 'DOMAIN_SEPARATOR',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'PERMIT_TYPEHASH',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'cashToken',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'details',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]',
      },
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'guranteedPayouts',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'nonGuranteedPayouts',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'nonces',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'deadline',
        type: 'uint256',
      },
      {
        internalType: 'uint8',
        name: 'v',
        type: 'uint8',
      },
      {
        internalType: 'bytes32',
        name: 'r',
        type: 'bytes32',
      },
      {
        internalType: 'bytes32',
        name: 's',
        type: 'bytes32',
      },
    ],
    name: 'permit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'policyTokenBalance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';

type PolicyTokenConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: PolicyTokenConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class PolicyToken__factory extends ContractFactory {
  constructor(...args: PolicyTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = 'PolicyToken';
  }

  override deploy(
    projectName_: PromiseOrValue<string>,
    tokenSymbol_: PromiseOrValue<string>,
    firstOwner: PromiseOrValue<string>,
    _cashToken: PromiseOrValue<string>,
    _startDate: PromiseOrValue<BigNumberish>,
    _guranteedPayouts: PromiseOrValue<BigNumberish>[],
    _nonGuranteedPayouts: PromiseOrValue<BigNumberish>[],
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<PolicyToken> {
    return super.deploy(
      projectName_,
      tokenSymbol_,
      firstOwner,
      _cashToken,
      _startDate,
      _guranteedPayouts,
      _nonGuranteedPayouts,
      overrides || {}
    ) as Promise<PolicyToken>;
  }
  override getDeployTransaction(
    projectName_: PromiseOrValue<string>,
    tokenSymbol_: PromiseOrValue<string>,
    firstOwner: PromiseOrValue<string>,
    _cashToken: PromiseOrValue<string>,
    _startDate: PromiseOrValue<BigNumberish>,
    _guranteedPayouts: PromiseOrValue<BigNumberish>[],
    _nonGuranteedPayouts: PromiseOrValue<BigNumberish>[],
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      projectName_,
      tokenSymbol_,
      firstOwner,
      _cashToken,
      _startDate,
      _guranteedPayouts,
      _nonGuranteedPayouts,
      overrides || {}
    );
  }
  override attach(address: string): PolicyToken {
    return super.attach(address) as PolicyToken;
  }
  override connect(signer: Signer): PolicyToken__factory {
    return super.connect(signer) as PolicyToken__factory;
  }
  static readonly contractName: 'PolicyToken';

  public readonly contractName: 'PolicyToken';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PolicyTokenInterface {
    return new utils.Interface(_abi) as PolicyTokenInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): PolicyToken {
    return new Contract(address, _abi, signerOrProvider) as PolicyToken;
  }
}
